// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1XZaC","errorLogs":"EditorFooter_errorLogs__oK0qz"};